import Metragem from "../components/Graficos/Metragem";
import { Producao } from "../components/Tabelas/Producao";
import ProducaoGeral from "../components/ProducaoGeral";
import Quebras from "../components/Graficos/Quebras";
import Rolo from "../components/Tabelas/Rolo";
import QuebrasCemMil from "../components/Tabelas/QuebrasCemMil";
import EficienciaGeral from "../components/Graficos/EficienciaGeral";
import QuebrasTear from "../components/Graficos/QuebrasTear";
import { useReport } from "../context/report";
import Residuos from "./Tabelas/Residuos";
import Artigo from "./Tabelas/Artigo";
import { Engrupagens } from "./Tabelas/Engrupagens";
import { EficienciaAbaixo } from "../pages/Producao/EficienciaAbaixo";
import { Cortes } from "./Tabelas/Cortes";
import { QuebrasTempos } from "./Tabelas/QuebrasTempos";
import { TesteGomaRolada } from "./Tabelas/TesteGomaRolada";
import ProducaoReal from "./Graficos/ProducaoReal";
import CortesTecido from "./Tabelas/CortesTecido";
import GeralColaborador from "./Tabelas/GeralColaborador";
import { TesteGoma } from "../pages/Producao/TesteGoma";
import ConsumoFio from "./Tabelas/ConsumoFio";
import EficienciaReal from "./Tabelas/EficienciaReal";
import EficienciaBaixaDia from "./Tabelas/EficienciaBaixaDia";
import { PontosPrimeiraQualidade } from "./Tabelas/PontosPrimeiraQualidade";
import { QuebrasEngomagemTecelagem } from "./Tabelas/QuebrasEngomagemTecelagem";

export default function Report({ type }) {
    const { data } = useReport();

    const reportsList = {
        'rolo': <Rolo />,
        'metragem': <Metragem />,
        'quebras': <Quebras />,
        'producao': <Producao />,
        'producaogeral': <ProducaoGeral />,
        'paradas': <EficienciaGeral />,
        'quebrastear': <QuebrasTear />,
        'quebrascemmil': <QuebrasCemMil />,
        'residuos': <Residuos />,
        'artigo': <Artigo />,
        'engreeng': <Engrupagens />,
        'eficienciaabaixo': <EficienciaAbaixo />,
        'testegoma': <TesteGoma />,
        'cortes': <Cortes />,
        'quebrastempos': <QuebrasTempos />,
        'testegomarolada': <TesteGomaRolada />,
        'producaoreal': <ProducaoReal />,
        'cortestecido': <CortesTecido />,
        'geralcolaborador': <GeralColaborador />,
        'consumofio': <ConsumoFio />,
        'eficienciareal': <EficienciaReal />,
        'eficienciabaixagrupo': <EficienciaBaixaDia />,
        'pontosprimeiraqualidade': <PontosPrimeiraQualidade />,
        'quebrasengomagemtecelagem': <QuebrasEngomagemTecelagem />
    }

    if(data === null) {
        return null;
    }

    return reportsList[type];
};